var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"questions-overview"},[_c('ul',{staticClass:"questions-overview-list"},_vm._l((_vm.questions),function(question,index){return _c('li',{key:question.Question.id,staticClass:"questions-overview-list-item",class:{
        answered: _vm.isQuestionAnswered(question),
        validated: _vm.isQuestionValidated(question),
        correct: _vm.isQuestionAnswerCorrect(question),
        current: index === _vm.currentIndex,
      },attrs:{"role":_vm.lockNavigation ? '' : 'button'},on:{"click":function($event){return _vm.onItemClick(index)}}},[_vm._v(" "+_vm._s(index + 1)+" ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }